import { Component, OnInit } from '@angular/core';
import { BPGAdminHomeService } from './bpg-admin-home.service';
import * as Highcharts from 'highcharts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
import { Router } from '@angular/router';
import { BpgEventsService } from '../bpg-events/bpg-events.service';

@Component({
  selector: 'bpg-admin-home-page',
  templateUrl: './bpg-admin-home-page.component.html',
  styleUrls: ['./bpg-admin-home-page.component.css']
})
export class BPGAdminHomePageComponent implements OnInit {
  // testing
  Highcharts: typeof Highcharts = Highcharts;
  budgetChartOptions: Highcharts.Options = {
    chart: {
      type: 'column'
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          fontWeight: 'bold' // Make x-axis labels bold
        }
      }
    },
    yAxis: {
      title: {
        text: ''
      },
      gridLineWidth: 1, // Remove horizontal grid lines
      labels: {
        enabled: false // Hide y-axis labels
      }
    },
    plotOptions: {
      column: {
        pointWidth: 50,
        pointPadding: 0, // Decrease the space between bars
        groupPadding: 0,
        borderWidth: 0,
        // minPointLength: 5, 
         dataLabels: {
          enabled: true, // Enable data labels
          format: '$'+ '{y}' ,// Display the value
          color: '#b62027'
        },
        states: {
          hover: {
            enabled: false // Disable hover state
          }
        }
      },
      series: {
        animation: {
            duration: 5 // Set the duration to 500 milliseconds
        }
      }
    },
    series: [{
      type: 'column',
      name: 'count',
      data: [],
      color: '#dbe0e0' 
    }],
    legend: {
      enabled: false // Turn off the legend
    },
    tooltip: {
      enabled: false // Disable tooltips
    },
    credits: {
      enabled: false // Disable the Highcharts.com hyperlink
    }
  };

  membershipChartOptions: Highcharts.Options = {
    chart: {
      type: 'column'
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: [],
      labels: {
        style: {
          fontWeight: 'bold' // Make x-axis labels bold
        }
      }
    },
    yAxis: {
      title: {
        text: ''
      },
      gridLineWidth: 1, // Remove horizontal grid lines
      labels: {
        enabled: false // Hide y-axis labels
      }
    },
    plotOptions: {
      column: {
        pointWidth: 30,
        pointPadding: 0, // Decrease the space between bars
        groupPadding: 0,
        borderWidth: 0,
         dataLabels: {
          enabled: true, // Enable data labels
          format: '{y}' ,// Display the value
          color: '#b62027',
          allowOverlap: false
        },
        states: {
          hover: {
            enabled: false // Disable hover state
          }
        }
      },
      series: {
        animation: {
            duration: 5 // Set the duration to 500 milliseconds
        }
      }
    },
    series: [{
      type: 'column',
      name: 'count',
      data: [],
      color: '#dbe0e0' 
    }],
    legend: {
      enabled: false // Turn off the legend
    },
    tooltip: {
      enabled: false // Disable tooltips
    },
    credits: {
      enabled: false // Disable the Highcharts.com hyperlink
    }
  };

  homePageData: any = {};
  eventsData = [];
  budgetData = [];
  siteData = [];
  chaptersData = [];
  ergData = [];
  currentFyTotalChapterBudget:number;
  currentFyAvailableChapterBudget:number;
  currentFyClaimedChapterBudget:number;
  virtualMembershipCount:number;
  regularMembershipCount:number;
  isErgAdmin: boolean;
  landingData : any;
  isErgLeadAdmin: boolean;
  isNaacAdmin: boolean;
  adminId: string;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  userId : any;
  chapterId : any;
  ergId: any;
  siteId: any;
  showFilters: boolean;
  eventList = [];
  currentFiscalYear: number;
  prevFiscalYear: number;
  currentFiscalYearString:any;
  prevFiscalYearString: any;
  today: Date;
  selectAllConstant = "Select All";
  prevFyAvailableChapterBudget: any;
  prevFyTotalChapterBudget: any;
  prevFyClaimedchapterBudget: any;
  currFySelected = true;
  constructor(private readonly newHomeService: BPGAdminHomeService,
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly environment: EnvironmentConfiguration,
    private readonly router: Router,
    private readonly  bpgEventsService : BpgEventsService) {}

  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
      if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }
    window.scrollTo(0, 0)
    // this.spinner.show();

    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isErgAdmin = true
    }
    if(localStorage.getItem('isbpgLeadAdmin')==='true'){
      this.isErgLeadAdmin = true;
    }
    if(localStorage.getItem('isNaacAdmin') === 'true')
    {
      this.isNaacAdmin = true
    }
    // get chapter details and call api with chapterId
    this.userId = this.loginData['userId'];
      // Update chart data after fetching the data
      this.spinner.show();
      this.today = new Date();
      const year = new Date().getFullYear();
      const month = new Date().getMonth() + 1;
    // If the month is before April, the fiscal year is the previous year
      if (month < 4) {
          this.currentFiscalYear = year;
      } else {
          this.currentFiscalYear = year+1;
      }
      this.prevFiscalYear = this.currentFiscalYear - 1;
      this.currentFiscalYearString = `FY${(this.currentFiscalYear) % 100}`;
      this.prevFiscalYearString = `FY${(this.currentFiscalYear-1) % 100}`;
      this.getChapterDetails();
      this.spinner.hide();
  }
  updateBudgetData(fiscalYear:any){
    this.currFySelected = fiscalYear==this.currentFiscalYear;
     if(fiscalYear==this.currentFiscalYear){
      const amountList = [this.currentFyTotalChapterBudget,this.currentFyClaimedChapterBudget,this.currentFyAvailableChapterBudget];
      (this.budgetChartOptions.series[0] as Highcharts.SeriesColumnOptions).data = amountList;
     }else{
      const amountList = [this.prevFyTotalChapterBudget,this.prevFyClaimedchapterBudget,this.prevFyAvailableChapterBudget];
      (this.budgetChartOptions.series[0] as Highcharts.SeriesColumnOptions).data = amountList;
     }
     Highcharts.chart('budgetGraph', this.budgetChartOptions);
  }
  getChapterDetails() {
    this.newHomeService.getChapterData().subscribe((res) => {
      if(res!=null){
        this.chaptersData = res;
        if(this.chaptersData.length===1){
             this.showFilters = false;
        }else{
        // Extract siteIds and siteNames into one list
        this.showFilters = true;
        this.siteData =  Array.from(new Set(this.chaptersData.map(item => JSON.stringify({ siteId: item.siteId, siteName: item.siteName }))))
        .map(item => JSON.parse(item));        // Extract bpgIds and bpgNames into another list
        this.siteData.unshift({ siteId: 0, siteName: this.selectAllConstant });
        this.siteId = this.siteData[0].siteId;
        this.ergData = [];
        this.chaptersData.forEach(item => {
          const exists = this.ergData.some(bpg => bpg.bpgId === item.bpgId);
          if (!exists) {
            this.ergData.push({ bpgId: item.bpgId, bpgName: item.bpgName });
          }
        });
        this.ergData.unshift({ bpgId: 0, bpgName: this.selectAllConstant});
        if(this.ergData.length>0){
          this.ergId = this.ergData[0].bpgId;
        }
        }
        // this.chapterId = this.chaptersData[0].chapterId;
        // this.getAllChapterEvents(this.chapterId);
        this.updateChartData();
      }
    });
    
  }

  updateChartData() {
    this.spinner.show();
   const data = {
    siteId: this.siteId==0 ? null : this.siteId,
    bpgId: this.ergId==0? null : this.ergId
   }
    this.newHomeService.getHomeData(data).subscribe((res) => {
      this.spinner.hide();
      this.homePageData = res.approvedBudget;
      this.eventsData = res.upcomingEventsList;
      this.budgetData = res.upcomingBudgets;
      this.currentFyAvailableChapterBudget = res.currentFyRemainingBudget;
      this.currentFyClaimedChapterBudget = res.currentFyClaimedBudget;
      this.currentFyTotalChapterBudget = res.currentFyApprovedBudget;
      this.virtualMembershipCount = res.virtualMembershipCount;
      this.regularMembershipCount = res.regularMembershipCount;
      this.prevFyAvailableChapterBudget = res.preFyRemainingBudget;
      this.prevFyTotalChapterBudget = res.preFyApprovedBudget;
      this.prevFyClaimedchapterBudget = res.preFyClaimedBudget;
      const amountList = [this.currentFyTotalChapterBudget,this.currentFyClaimedChapterBudget,this.currentFyAvailableChapterBudget];
      const list = ['Total','Claimed','Remaining'];
      (this.budgetChartOptions.xAxis as Highcharts.XAxisOptions).categories = list;
      (this.budgetChartOptions.series[0] as Highcharts.SeriesColumnOptions).data = amountList;
      (this.membershipChartOptions.xAxis as Highcharts.XAxisOptions).categories = res.sixMonthsList;
      (this.membershipChartOptions.series[0] as Highcharts.SeriesColumnOptions).data = res.regularMembershipCountList;
      // this.updateExtremes(amountList,"budget");
      // this.updateExtremes(res.totalMembershipCountList,"membership");
      Highcharts.chart('membershipGraph', this.membershipChartOptions);
      Highcharts.chart('budgetGraph', this.budgetChartOptions);
      this.currFySelected = true;
  });
  }

  // Function to update the min and max values dynamically
updateExtremes(values:any,type:string) {
  const minValue = Math.min(...values);
  const maxValue = Math.max(...values);
  if(type==='budget' && minValue == 0 && maxValue == 0){
    (this.budgetChartOptions.yAxis as Highcharts.YAxisOptions).min =  0;
    (this.budgetChartOptions.yAxis as Highcharts.YAxisOptions).max = 5;
    (this.budgetChartOptions.yAxis as Highcharts.YAxisOptions).gridLineWidth = 0;
    (this.budgetChartOptions.yAxis as Highcharts.YAxisOptions).labels = {
    enabled: false
    };
  }
  if(type==='membership' && minValue == 0 && maxValue == 0){
    (this.membershipChartOptions.yAxis as Highcharts.YAxisOptions).min = 0;
    (this.membershipChartOptions.yAxis as Highcharts.YAxisOptions).max = maxValue==0 ? 1 : maxValue+5;
  }
}

public siteChange(event) {
  if (event !== undefined) {
    this.siteId = event.siteId;
  } else {
    this.siteId = null;
  }
}

public bpgChange(event){
  if (event !== undefined) {
    this.ergId = event.bpgId;
  } else {
    this.ergId = null;
  }
  if(this.ergId!=null){
    this.filterSiteList();
  }
}
searchChapter(){
  // this.spinner.show();
  this.updateChartData();
  // if(this.bpgId!=null && this.siteId!=null){
  //   this.chaptersData.forEach(item => {
  //     if (item.bpgId === this.bpgId && item.siteId === this.siteId) {
  //       this.chapterId = item.chapterId;
  //       this.getAllChapterEvents(this.chapterId);
       
  //     }
  //   });
  // }
}

filterSiteList(){
  this.siteData = [];
  this.chaptersData.forEach(item => {
    if(item.bpgId==this.ergId){
      const exists = this.siteData.some(site => site.siteId === item.siteId);
      if (!exists) {
        this.siteData.push({ siteId: item.siteId, siteName: item.siteName });
      }
    }
  });
  this.siteData.unshift({ siteId: 0, siteName: this.selectAllConstant});
  if(this.siteData.length>0){
    this.siteId = this.siteData[0].siteId;
  }
}

redirectToEvent(eventId:any){
  this.router.navigate(['/event-view-details', eventId]);
}

redirectToExpense(expenseId:any,status:any){
  if(status==='APPROVED' || status==='SUBMITTED'){
    this.router.navigate(['/claim-expense-approval',expenseId]);
  }else{
    this.router.navigate(['/expense-claim', expenseId]);
  }
}

getAllChapterEvents(chapterId: any) {
  this.landingData = 
      {
        "filter": {
        "chapterId":this.chapterId,
        "fiscalYear": this.currentFiscalYear+1,
        "eventType":"upcoming"
        },
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm": '',
        "size": 2000,
        "sortDirection": "ASC",
        "sortProperty": "event_create_date",
        "uid": ""
      }
      this.bpgEventsService.getAllEvents(this.landingData).subscribe(data=>{
        this.eventList = data.content;
        this.spinner.hide();
      });
}
// print events logic
printEvents(){
  const printContents = document.getElementById('printEvents').innerHTML;
  const originalContents = document.body.innerHTML;
  document.body.innerHTML = printContents;
  window.print();
  document.body.innerHTML = originalContents;
  location.reload();
}

}

